/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './BusinessUnitsService';
import * as Queries from './BusinessUnitsService.dfc.new';
import type { AdditionalContextArgs } from './BusinessUnitsService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetBusinessUnitsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetBusinessUnitsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getBusinessUnits', References.GetBusinessUnitsResponseType>
        : References.GetBusinessUnitsResponseType)
    | undefined;
};

export function useGetBusinessUnitsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetBusinessUnitsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BUSINESS_UNITS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBusinessUnits: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBusinessUnitsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetBusinessUnitsQueryReturn<T>;
}

type UseGetBusinessUnitsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetBusinessUnitsResponseType>,
    {},
    T extends true
      ? Record<'getBusinessUnits', References.GetBusinessUnitsResponseType>
      : References.GetBusinessUnitsResponseType
  >;

export function useGetBusinessUnitsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetBusinessUnitsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BUSINESS_UNITS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBusinessUnits: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetBusinessUnitsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetBusinessUnitsLazyQueryReturn<T>;
}

type UseGetBusinessUnitsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetBusinessUnitsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getBusinessUnits', References.GetBusinessUnitsResponseType>
    : References.GetBusinessUnitsResponseType;
};

export function useGetBusinessUnitsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetBusinessUnitsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BUSINESS_UNITS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getBusinessUnits: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBusinessUnitsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBusinessUnitsSuspenseQueryReturn<T>;
}

type UseGetBusinessUnitsByUserQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetBusinessUnitsByUserResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getBusinessUnitsByUser',
            References.GetBusinessUnitsByUserResponseType
          >
        : References.GetBusinessUnitsByUserResponseType)
    | undefined;
};

export function useGetBusinessUnitsByUserQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetBusinessUnitsByUserResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitsByUserQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BUSINESS_UNITS_BY_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBusinessUnitsByUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBusinessUnitsByUserQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBusinessUnitsByUserQueryReturn<T>;
}

type UseGetBusinessUnitsByUserLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetBusinessUnitsByUserResponseType>,
    {},
    T extends true
      ? Record<
          'getBusinessUnitsByUser',
          References.GetBusinessUnitsByUserResponseType
        >
      : References.GetBusinessUnitsByUserResponseType
  >;

export function useGetBusinessUnitsByUserLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetBusinessUnitsByUserResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitsByUserLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BUSINESS_UNITS_BY_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBusinessUnitsByUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetBusinessUnitsByUserLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetBusinessUnitsByUserLazyQueryReturn<T>;
}

type UseGetBusinessUnitsByUserSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetBusinessUnitsByUserResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getBusinessUnitsByUser',
        References.GetBusinessUnitsByUserResponseType
      >
    : References.GetBusinessUnitsByUserResponseType;
};

export function useGetBusinessUnitsByUserSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetBusinessUnitsByUserResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitsByUserSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BUSINESS_UNITS_BY_USER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getBusinessUnitsByUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBusinessUnitsByUserSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBusinessUnitsByUserSuspenseQueryReturn<T>;
}

type UseGetBusinessUnitByIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetBusinessUnitByIdResponseType>,
    References.GetBusinessUnitByIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getBusinessUnitById',
            References.GetBusinessUnitByIdResponseType
          >
        : References.GetBusinessUnitByIdResponseType)
    | undefined;
};

export function useGetBusinessUnitByIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetBusinessUnitByIdResponseType>,
    References.GetBusinessUnitByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitByIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BUSINESS_UNIT_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBusinessUnitById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBusinessUnitByIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBusinessUnitByIdQueryReturn<T>;
}

type UseGetBusinessUnitByIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetBusinessUnitByIdResponseType>,
    References.GetBusinessUnitByIdRequestType,
    T extends true
      ? Record<
          'getBusinessUnitById',
          References.GetBusinessUnitByIdResponseType
        >
      : References.GetBusinessUnitByIdResponseType
  >;

export function useGetBusinessUnitByIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetBusinessUnitByIdResponseType>,
    References.GetBusinessUnitByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitByIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BUSINESS_UNIT_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBusinessUnitById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetBusinessUnitByIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetBusinessUnitByIdLazyQueryReturn<T>;
}

type UseGetBusinessUnitByIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetBusinessUnitByIdResponseType>,
    References.GetBusinessUnitByIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getBusinessUnitById', References.GetBusinessUnitByIdResponseType>
    : References.GetBusinessUnitByIdResponseType;
};

export function useGetBusinessUnitByIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetBusinessUnitByIdResponseType>,
    References.GetBusinessUnitByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBusinessUnitByIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BUSINESS_UNIT_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getBusinessUnitById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBusinessUnitByIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBusinessUnitByIdSuspenseQueryReturn<T>;
}

type UseCreateBusinessUnitMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateBusinessUnitResponseType>,
    References.CreateBusinessUnitRequestType,
    T extends true
      ? Record<'createBusinessUnit', References.CreateBusinessUnitResponseType>
      : References.CreateBusinessUnitResponseType
  >;

export function useCreateBusinessUnitMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateBusinessUnitResponseType>,
    References.CreateBusinessUnitRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateBusinessUnitMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_BUSINESS_UNIT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateBusinessUnitMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateBusinessUnitMutationReturn<T>;
}

type UseUpdateBusinessUnitMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateBusinessUnitResponseType>,
    References.UpdateBusinessUnitRequestType,
    T extends true
      ? Record<'updateBusinessUnit', References.UpdateBusinessUnitResponseType>
      : References.UpdateBusinessUnitResponseType
  >;

export function useUpdateBusinessUnitMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateBusinessUnitResponseType>,
    References.UpdateBusinessUnitRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateBusinessUnitMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_BUSINESS_UNIT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateBusinessUnitMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateBusinessUnitMutationReturn<T>;
}

type UseDeleteBusinessUnitMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DeleteBusinessUnitResponseType>,
    References.DeleteBusinessUnitRequestType,
    T extends true
      ? Record<'deleteBusinessUnit', References.DeleteBusinessUnitResponseType>
      : References.DeleteBusinessUnitResponseType
  >;

export function useDeleteBusinessUnitMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteBusinessUnitResponseType>,
    References.DeleteBusinessUnitRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteBusinessUnitMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_BUSINESS_UNIT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteBusinessUnitMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteBusinessUnitMutationReturn<T>;
}

type UseGetUserDefaultBusinessUnitQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetUserDefaultBusinessUnitResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getUserDefaultBusinessUnit',
            References.GetUserDefaultBusinessUnitResponseType
          >
        : References.GetUserDefaultBusinessUnitResponseType)
    | undefined;
};

export function useGetUserDefaultBusinessUnitQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetUserDefaultBusinessUnitResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserDefaultBusinessUnitQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_USER_DEFAULT_BUSINESS_UNIT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserDefaultBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserDefaultBusinessUnitQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserDefaultBusinessUnitQueryReturn<T>;
}

type UseGetUserDefaultBusinessUnitLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetUserDefaultBusinessUnitResponseType>,
    {},
    T extends true
      ? Record<
          'getUserDefaultBusinessUnit',
          References.GetUserDefaultBusinessUnitResponseType
        >
      : References.GetUserDefaultBusinessUnitResponseType
  >;

export function useGetUserDefaultBusinessUnitLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetUserDefaultBusinessUnitResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserDefaultBusinessUnitLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USER_DEFAULT_BUSINESS_UNIT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserDefaultBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUserDefaultBusinessUnitLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUserDefaultBusinessUnitLazyQueryReturn<T>;
}

type UseGetUserDefaultBusinessUnitSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetUserDefaultBusinessUnitResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getUserDefaultBusinessUnit',
        References.GetUserDefaultBusinessUnitResponseType
      >
    : References.GetUserDefaultBusinessUnitResponseType;
};

export function useGetUserDefaultBusinessUnitSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetUserDefaultBusinessUnitResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserDefaultBusinessUnitSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USER_DEFAULT_BUSINESS_UNIT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUserDefaultBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserDefaultBusinessUnitSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserDefaultBusinessUnitSuspenseQueryReturn<T>;
}

type UseSetUserDefaultBusinessUnitMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetUserDefaultBusinessUnitResponseType>,
    References.SetUserDefaultBusinessUnitRequestType,
    T extends true
      ? Record<
          'setUserDefaultBusinessUnit',
          References.SetUserDefaultBusinessUnitResponseType
        >
      : References.SetUserDefaultBusinessUnitResponseType
  >;

export function useSetUserDefaultBusinessUnitMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.SetUserDefaultBusinessUnitResponseType>,
    References.SetUserDefaultBusinessUnitRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetUserDefaultBusinessUnitMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_USER_DEFAULT_BUSINESS_UNIT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setUserDefaultBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetUserDefaultBusinessUnitMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetUserDefaultBusinessUnitMutationReturn<T>;
}

type UseClearUserDefaultBusinessUnitMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ClearUserDefaultBusinessUnitResponseType>,
    {},
    T extends true
      ? Record<
          'clearUserDefaultBusinessUnit',
          References.ClearUserDefaultBusinessUnitResponseType
        >
      : References.ClearUserDefaultBusinessUnitResponseType
  >;

export function useClearUserDefaultBusinessUnitMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.ClearUserDefaultBusinessUnitResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseClearUserDefaultBusinessUnitMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CLEAR_USER_DEFAULT_BUSINESS_UNIT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            clearUserDefaultBusinessUnit: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseClearUserDefaultBusinessUnitMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseClearUserDefaultBusinessUnitMutationReturn<T>;
}

type UseGetPrimaryBrandIdQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetPrimaryBrandIdResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getPrimaryBrandId', References.GetPrimaryBrandIdResponseType>
        : References.GetPrimaryBrandIdResponseType)
    | undefined;
};

export function useGetPrimaryBrandIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPrimaryBrandIdResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPrimaryBrandIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PRIMARY_BRAND_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPrimaryBrandId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPrimaryBrandIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetPrimaryBrandIdQueryReturn<T>;
}

type UseGetPrimaryBrandIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPrimaryBrandIdResponseType>,
    {},
    T extends true
      ? Record<'getPrimaryBrandId', References.GetPrimaryBrandIdResponseType>
      : References.GetPrimaryBrandIdResponseType
  >;

export function useGetPrimaryBrandIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPrimaryBrandIdResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPrimaryBrandIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PRIMARY_BRAND_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPrimaryBrandId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPrimaryBrandIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPrimaryBrandIdLazyQueryReturn<T>;
}

type UseGetPrimaryBrandIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPrimaryBrandIdResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPrimaryBrandId', References.GetPrimaryBrandIdResponseType>
    : References.GetPrimaryBrandIdResponseType;
};

export function useGetPrimaryBrandIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPrimaryBrandIdResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPrimaryBrandIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PRIMARY_BRAND_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPrimaryBrandId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPrimaryBrandIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPrimaryBrandIdSuspenseQueryReturn<T>;
}

type UseSetPrimaryBrandIdMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetPrimaryBrandIdResponseType>,
    References.SetPrimaryBrandIdRequestType,
    T extends true
      ? Record<'setPrimaryBrandId', References.SetPrimaryBrandIdResponseType>
      : References.SetPrimaryBrandIdResponseType
  >;

export function useSetPrimaryBrandIdMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetPrimaryBrandIdResponseType>,
    References.SetPrimaryBrandIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetPrimaryBrandIdMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_PRIMARY_BRAND_ID_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setPrimaryBrandId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetPrimaryBrandIdMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetPrimaryBrandIdMutationReturn<T>;
}
